module.exports = __webpack_public_path__ + "static/media/599.7554(7).730277df.pdf";